import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import {
  BtnGroupStyle,
  ContentStyle,
  DataGridListStyle,
  SearchBox,
} from "../../Theme";
import { v4 as uuid } from "uuid";
import { YSButton } from "../../uikit/YSButton";
import { HelpGuideTooltip } from "../../components/HelpGuideTooltip";
import useFetch from "../../CustomHooks/useFetch";
import {
  staffAuthorizationSearchbyLastname,
  staffAuthorizationUpdate,
} from "../../Apis/AuthApiServices";
import { useEffect, useState } from "react";
import NoRecords from "../../components/NoRecords";
import ErrorOverlay from "../../components/ErrorOverlay";
import useDebounce from "../../CustomHooks/useDebounce";
import YSSnackBar from "../../uikit/YSSnackBar";
import { useSelector } from "react-redux";

export default function StaffAuthorization() {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [smallLoad, setSmallLoad] = useState(false);
  const [lastName, setLastName] = useState("");
  const [staffAuthorization, setStaffAuthorizationDetails] =
    useState<Object | null>(null);
  const LastNameDebounceValue = useDebounce(lastName, 1000);
  const [stateData, setStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data

  const doctorId: any = localStorage.getItem("doctorId");
  const Params = {
    doctorId: doctorId,
    lastName: LastNameDebounceValue,
    pageNumber: page,
  };
  const { data, loading, error, fetchApi }: any = useFetch(
    Params,
    staffAuthorizationSearchbyLastname,
    [page, LastNameDebounceValue]
  );
  const [rowCountState, setRowCountState] = useState(
    data[0]?.pagination?.totalItems || 0
  );

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      data[0]?.pagination?.totalItems !== undefined
        ? data[0]?.pagination?.totalItems
        : prevRowCountState
    );
  }, [data[0]?.pagination?.totalItems, setRowCountState]);

  function CheckboxOnly(prop: any) {
    return (
      <Box style={{ marginLeft: "-11px" }}>
        <Checkbox
          name={prop.name}
          defaultChecked={prop.defaultChecked}
          style={{ background: "transparent" }}
          checked={prop.checked}
          disabled={prop.disabled}
          onChange={(opt, e) => {
            prop.row[prop.name] = e;
            let obj: any = {};
            obj[`${prop.row.id}`] = prop.row;
            setStaffAuthorizationDetails({ ...staffAuthorization, ...obj });
          }}
        />
      </Box>
    );
  }

  const updateStatus = async () => {
    try {
      if (staffAuthorization) {
        setSmallLoad(true);

        const data = {
          staffAuthorizationDetails: Object.values(staffAuthorization ?? {}),
        };
        const result = await staffAuthorizationUpdate(data);
        if (result?.data?.digitalRxStatusCode === 200) {
          setStaffAuthorizationDetails(null);
          setSmallLoad(false);
          setStateData((prevState: any) => {
            return {
              ...prevState,
              message: result?.data?.response[0]?.message,
              variant: "success",
              open: true,
            };
          });
          fetchApi();
        } else {
          setStaffAuthorizationDetails(null);
          setSmallLoad(false);
          setStateData((prevState: any) => {
            return {
              ...prevState,
              message: result?.data?.digitalRxStatusMessage,
              variant: "error",
              open: true,
            };
          });
        }
      } else {
        setSmallLoad(false);
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: "Please Make Changes",
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err) {
      setStaffAuthorizationDetails(null);
      setSmallLoad(false);
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try again after sometime",
          variant: "error",
          open: true,
        };
      });
    }
  };
  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Name",
      width: 190,
      cellClassName: "w25",
      headerClassName: "w25",
    },

    {
      field: "profile",
      headerName: "Profile",
      width: 190,
      cellClassName: "w25",
      headerClassName: "w25",
    },
    {
      field: "savePrescriptions",
      headerName: "SP",
      width: 60,
      cellClassName: "w8",
      headerClassName: "w8",
      renderCell: ({ row }) => {
        return (
          <CheckboxOnly
            name="savePrescriptions"
            defaultChecked={
              row?.lowerProfileFlag ? row?.savePrescriptions : true
            }
            disabled={
              UserServiceState?.profileGroup > 9
                ? true
                : row?.lowerProfileFlag
                ? false
                : true
            }
            row={row}
          />
        );
      },
    },
    {
      field: "printReports",
      headerName: "PR",
      width: 60,
      cellClassName: "w8",
      headerClassName: "w8",
      renderCell: ({ row }) => {
        return (
          <CheckboxOnly
            name="printReports"
            defaultChecked={row?.lowerProfileFlag ? row?.printReports : true}
            disabled={
              UserServiceState?.profileGroup > 9
                ? true
                : row?.lowerProfileFlag
                ? false
                : true
            }
            row={row}
          />
        );
      },
    },
    {
      field: "editPatientAllergy",
      headerName: "EPA",
      width: 60,
      cellClassName: "w8",
      headerClassName: "w8",
      renderCell: ({ row }) => {
        return (
          <CheckboxOnly
            name="editPatientAllergy"
            defaultChecked={
              row?.lowerProfileFlag ? row?.editPatientAllergy : true
            }
            disabled={
              UserServiceState?.profileGroup > 9
                ? true
                : row?.lowerProfileFlag
                ? false
                : true
            }
            row={row}
          />
        );
      },
    },
    {
      field: "editpatientMedicationHistory",
      headerName: "EPM",
      width: 60,
      cellClassName: "w8",
      headerClassName: "w8",
      renderCell: ({ row }) => {
        return (
          <CheckboxOnly
            name="editpatientMedicationHistory"
            defaultChecked={
              row?.lowerProfileFlag ? row?.editpatientMedicationHistory : true
            }
            disabled={
              UserServiceState?.profileGroup > 9
                ? true
                : row?.lowerProfileFlag
                ? false
                : true
            }
            row={row}
          />
        );
      },
    },
    {
      field: "onBehalfNewrx",
      headerName: "OBN",
      width: 60,
      cellClassName: "w8",
      headerClassName: "w8",
      renderCell: ({ row }) => {
        return (
          <CheckboxOnly
            name="onBehalfNewrx"
            defaultChecked={row?.onBehalfNewrx}
            disabled={UserServiceState?.profileGroup > 9 ? true : false}
            row={row}
          />
        );
      },
    },
    {
      field: "onBehalfRefill",
      headerName: "OBR",
      width: 60,
      cellClassName: "w8",
      headerClassName: "w8",
      renderCell: ({ row }) => {
        return (
          <CheckboxOnly
            name="onBehalfRefill"
            defaultChecked={row?.onBehalfRefill}
            disabled={UserServiceState?.profileGroup > 9 ? true : false}
            row={row}
          />
        );
      },
    },
    {
      field: "onBehalfepa",
      headerName: "OBPA",
      width: 60,
      cellClassName: "w8",
      headerClassName: "w8",
      renderCell: ({ row }) => {
        return (
          <CheckboxOnly
            name="onBehalfepa"
            defaultChecked={row?.onBehalfepa}
            disabled={UserServiceState?.profileGroup > 9 ? true : false}
            row={row}
          />
        );
      },
    },
  ];
  return (
    <>
      <ContentStyle>
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12} md={6}>
            <Typography
              className="help"
              component="h6"
              color="primary"
              variant="h6"
            >
              Staff Authorization{" "}
              <HelpGuideTooltip
                content={
                  <>
                    <Typography component="div" variant="body1">
                      Section where the prescriber can authorize staff to
                      prescribe on-behalf of account holder
                    </Typography>
                  </>
                }
              />
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <SearchBox>
              <Typography component="label" color="primary" variant="body2">
                Search
              </Typography>{" "}
              <TextField
                id="lastName"
                name="lastName"
                variant="outlined"
                type={"text"}
                placeholder="Enter last name"
                style={{ marginBottom: 10, borderRadius: 100 }}
                onChange={(e: any) => {
                  setLastName(e.target.value);
                }}
              />{" "}
            </SearchBox>
          </Grid>
        </Grid>
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                columns={columns}
                rows={data[0]?.items ?? []}
                headerHeight={36}
                sortingOrder={["desc", "asc"]}
                paginationMode="server"
                autoHeight
                rowHeight={40}
                pageSize={pageSize}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={error || undefined}
                getRowId={(row) => row.personId ?? uuid()}
                pagination
                loading={loading}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                page={page}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                rowCount={rowCountState}
              />
            </DataGridListStyle>
          </Grid>
          <Grid item xs={12}>
            <BtnGroupStyle className="middle">
              <YSButton
                onClick={fetchApi}
                className=""
                children={"Reset"}
                size={"large"}
                type="reset"
                color="primary"
                variant="outlined"
              />{" "}
              <YSButton
                onClick={updateStatus}
                className=""
                children={
                  smallLoad ? (
                    <CircularProgress color="inherit" size={28} />
                  ) : (
                    "Update"
                  )
                }
                size={"large"}
                type="button"
                color="primary"
                variant="contained"
              />{" "}
            </BtnGroupStyle>
          </Grid>
          <Grid item xs={12}>
            <Box
              style={{
                display: "flex",
                columnGap: "35px",
                flexWrap: "wrap",
                rowGap: "10px",
                marginTop: 20,
              }}
            >
              <Typography
                component="div"
                variant="body2"
                style={{ whiteSpace: "nowrap", minWidth: 135 }}
              >
                <Typography
                  component="span"
                  color="primary"
                  variant="body2"
                  fontWeight={600}
                >
                  SP{" "}
                </Typography>
                Save Prescription
              </Typography>
              <Typography
                component="div"
                variant="body2"
                style={{ whiteSpace: "nowrap" }}
              >
                <Typography
                  component="span"
                  color="primary"
                  variant="body2"
                  fontWeight={600}
                >
                  PR{" "}
                </Typography>{" "}
                Print Reports
              </Typography>
              <Typography
                component="div"
                variant="body2"
                style={{ whiteSpace: "nowrap" }}
              >
                <Typography
                  component="span"
                  color="primary"
                  variant="body2"
                  fontWeight={600}
                >
                  EPA{" "}
                </Typography>{" "}
                Edit Patient Allergy
              </Typography>
              <Typography
                component="div"
                variant="body2"
                style={{ whiteSpace: "nowrap" }}
              >
                <Typography
                  component="span"
                  color="primary"
                  variant="body2"
                  fontWeight={600}
                >
                  OBN{" "}
                </Typography>{" "}
                On Behalf (NewRx)
              </Typography>
              <Typography
                component="div"
                variant="body2"
                style={{ whiteSpace: "nowrap" }}
              >
                <Typography
                  component="span"
                  color="primary"
                  variant="body2"
                  fontWeight={600}
                >
                  EPM{" "}
                </Typography>{" "}
                Edit Patient Medication History
              </Typography>
              <Typography
                component="div"
                variant="body2"
                style={{ whiteSpace: "nowrap" }}
              >
                <Typography
                  component="span"
                  color="primary"
                  variant="body2"
                  fontWeight={600}
                >
                  OBR{" "}
                </Typography>
                On Behalf (Refill)
              </Typography>
              <Typography
                component="div"
                variant="body2"
                style={{ whiteSpace: "nowrap" }}
              >
                <Typography
                  component="span"
                  color="primary"
                  variant="body2"
                  fontWeight={600}
                >
                  OBPA{" "}
                </Typography>{" "}
                On Behalf (ePA)
              </Typography>
            </Box>
          </Grid>
        </Grid>{" "}
      </ContentStyle>
      <YSSnackBar
        message={stateData.message}
        variant={stateData.variant}
        open={stateData.open}
        handleClose={() => {
          setStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
